const equipmentTypes = {
  reeferLessThanTruckload: [
    { value: "a0V1I000000HrZvUAK", label: "Reefer 53'" }
  ],
  reeferFullTruckLoadTeamDrivers: [
    { value: "a0V1I000000HrZvUAK", label: "Reefer 53'" },
    { value: "a0V1I000000HrZxUAK", label: "Reefer 48'" },
    { value: "a0V3s00000G57uAEAR", label: "Reefer 26'" },
    { value: "a0V3s00000cTmF4EAK", label: "Reefer Box Truck" },
    { value: "a0V3s00000dwDaKEAU", label: "Reefer Sprinter" }
  ],
  reeferFullTruckLoad: [
    { value: "a0V1I000000HrZvUAK", label: "Reefer 53'" },
    { value: "a0V1I000000HrZxUAK", label: "Reefer 48'" },
    { value: "a0V3s00000G57uAEAR", label: "Reefer 26'" },
    { value: "a0V3s00000cTmF4EAK", label: "Reefer Box Truck" },
    { value: "a0V3s00000dwDaKEAU", label: "Reefer Sprinter" }
  ],
  reeferDrayage: [{ value: "a0V1I0000098XccUAE", label: "Reefer Container" }],
  powerOnlyTowingDriveaway: [{ value: "a0VRc000002Jik9MAC", label: "Daycab" }],
  hhTransloading: [{ value: "a0V1I00000078wRUAQ", label: "RGN 5X" }],
  ftlFSD: [
    { value: "a0V1I00000078vsUAA", label: "FLATBED" },
    { value: "a0V1I00000078w7UAA", label: "STEPDECK" },
    { value: "a0V1I0000019rGKUAY", label: "HOTSHOT" },
    { value: "a0V1I000004n5d6UAA", label: "FLATBED CONESTOGA" },
    { value: "a0V1I000004n5dGUAQ", label: "STEPDECK CONESTOGA" },
    { value: "a0V1I000005vFSiUAM", label: "STEPDECK LOW PROFILE" }
  ],
  partialFSDLTLSpotMarket: [
    { value: "a0V1I00000078vsUAA", label: "FLATBED" },
    { value: "a0V1I00000078w7UAA", label: "STEPDECK" },
    { value: "a0V1I0000019rGKUAY", label: "HOTSHOT" },
    { value: "a0V1I000004n5d6UAA", label: "FLATBED CONESTOGA" },
    { value: "a0V1I000004n5dGUAQ", label: "STEPDECK CONESTOGA" },
    { value: "a0V1I000005vFSiUAM", label: "STEPDECK LOW PROFILE" }
  ],
  ozFTLFSD: [
    { value: "a0V1I00000078vsUAA", label: "FLATBED" },
    { value: "a0V1I00000078w7UAA", label: "STEPDECK" },
    { value: "a0V1I0000019rGKUAY", label: "HOTSHOT" }
  ],
  heavyHaulingSpecialized: [
    { value: "a0V1I00000078wRUAQ", label: "RGN 5X" },
    { value: "a0V1I00000078wWUAQ", label: "RGN 6X" },
    { value: "a0V1I00000078wbUAA", label: "RGN 7X" },
    { value: "a0V1I00000078wgUAA", label: "RGN 8X" },
    { value: "a0V1I00000078wlUAA", label: "RGN 9X" },
    { value: "a0V1I00000078wqUAA", label: "RGN 10X" },
    { value: "a0V1I000005vSvOUAU", label: "RGN 12X" },
    { value: "a0V1I00000078wvUAA", label: "RGN 13X" },
    { value: "a0V1I00000078x0UAA", label: "RGN 19X" },
    { value: "a0VRc000002F73GMAS", label: "DUAL TRUCK" }
  ],
  drayage: [
    { value: "a0V3s00000cSHIpEAO", label: "Container 40' HC Chassis" },
    { value: "a0V1I000000Hra6UAC", label: "Container 40' STD Chassis" },
    { value: "a0V1I0000019r3oUAA", label: "Container 40' FR Chassis" },
    { value: "a0V1I0000019r3jUAA", label: "Container 40' OT Chassis" },
    { value: "a0V1I000000Hra8UAC", label: "Container 20' STD Chassis" },
    { value: "a0V1I0000019r3eUAA", label: "Container 20' OT Chassis" },
    { value: "a0V1I0000019r3ZUAQ", label: "Container 20' FR Chassis" }
  ],
  ftlDry: [{ value: "a0V1I000000HrZoUAK", label: "Dry Van 53'" }],
  ftlDryTeamDrivers: [{ value: "a0V1I000000HrZoUAK", label: "Dry Van 53'" }],
  expedited: [
    { value: "a0V1I00000078xKUAQ", label: "Cargo Van" },
    { value: "a0V1I000000HrZoUAK", label: "Dry Van 53'" },
    { value: "a0V3s00000G4YvNEAV", label: "Sprinter" },
    { value: "a0VRc0000014C3dMAE", label: "Straight Box Truck" },
    { value: "a0V1I000003L9baUAC", label: "Straight Truck 26'" }
  ],
  partialVanLTLSpotMarket: [
    { value: "a0V1I000000HrZoUAK", label: "Dry Van 53'" },
    { value: "a0V1I000003L9baUAC", label: "Straight Truck 26'" }
  ],
  carCarrier: [{ value: "a0V1I0000019p52UAA", label: "Car Hauler" }],
  intermodalRail: [
    { value: "a0V1I0000019p4xUAA", label: "Container 53' Domestic" }
  ]
};

const equipmentMap = {
  "reefer less than truckload": equipmentTypes.reeferLessThanTruckload,
  "reefer full truck load team drivers":
    equipmentTypes.reeferFullTruckLoadTeamDrivers,
  "reefer full truck load": equipmentTypes.reeferFullTruckLoad,
  "reefer drayage": equipmentTypes.reeferDrayage,
  "power only - towing - driveaway": equipmentTypes.powerOnlyTowingDriveaway,
  "hh-transloading": equipmentTypes.hhTransloading,
  "ftl - f/sd": equipmentTypes.ftlFSD,
  "partial f/sd (ltl spot market)": equipmentTypes.partialFSDLTLSpotMarket,
  "oz ftl - f/sd": equipmentTypes.ozFTLFSD,
  "team drivers ftl - f/sd": equipmentTypes.teamDriversFTLFSD,
  "heavy hauling - specialized": equipmentTypes.heavyHaulingSpecialized,
  drayage: equipmentTypes.drayage,
  "ftl - dry": equipmentTypes.ftlDry,
  "ftl - dry team drivers": equipmentTypes.ftlDryTeamDrivers,
  expedited: equipmentTypes.expedited,
  "partial van (ltl spot market)": equipmentTypes.partialVanLTLSpotMarket,
  "car carrier": equipmentTypes.carCarrier,
  "intermodal/rail": equipmentTypes.intermodalRail
};

module.exports = { equipmentTypes, equipmentMap };
